/**
 * What to show for a failed API call: this screen's own wording for the code
 * when it has one, else apiReq's readable message.
 */
export const getApiErrorMessage = (
  error: { code: string; message: string },
  messages: Record<string, string>
): string => messages[error.code] ?? error.message;
